<!--
 * @Author: ZhaoG
 * @Date: 2025-04-14 16:18:19
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-04-18 15:31:20
 * @FilePath: \pp-fe\src\app\shop\views\announcementsListNew.vue
 * @Description: 
-->
<template>
  <!-- 供应商 -->
  <supList
    v-if="source === 'JTGYSML'"
    :currBreadCrumb="currBreadCrumb"
    :callInterface="sourceInterface"
    :source="source"
  ></supList>
  <!-- 交流论坛 -->
  <exchangeForum
    v-else-if="source === 'JLLT'"
    :curr-bread-crumb="currBreadCrumb"
    :activeIndex="activeIndex"
  >
  </exchangeForum>
  <commListJccg
    :currBreadCrumb="currBreadCrumb"
    :callInterface="sourceInterface"
    :source="source"
    :activeIndex="activeIndex"
    :sourceId="sourceId"
    v-else-if="source === '100068JCCG'"
  />
  <commList
    :currBreadCrumb="currBreadCrumb"
    :callInterface="sourceInterface"
    :source="source"
    :activeIndex="activeIndex"
    :sourceId="sourceId"
    v-else
  />
</template>

<script>
import {
  // 四种查询接口对应不同类型查询方法
  searchPpBidNotice,
  selectNoticeList,
  querySupplierDirectoryList,
  selectInformationPublishList,
  queryPurchasePriceList
} from "@/app/shop/api/shopping";
import supList from "@/app/shop/components/supList.vue";
import exchangeForum from "@/app/shop/components/exchangeForum.vue";
import { mapGetters } from "vuex";
import commList from "./commList.vue";
import commListJccg from "./commListJccg.vue";

export default {
  name: "announcementsList",
  components: {
    commList,
    supList,
    exchangeForum,
    commListJccg
  },
  data() {
    return {
      source: this.$route.query.source,
      activeIndex: this.$route.query.activeIndex,
      sourceId: this.$route.query.sourceId
    };
  },
  computed: {
    ...mapGetters({
      currBreadCrumb: "getCurrentBrand"
    }),
    sourceInterface() {
      console.log(this.$route.query.source, "111111111111111");
      // 采购公示 评标公示
      if (["100068ZBGG", "100068ZBXX"].includes(this.source)) {
        return searchPpBidNotice;
        // 集团供应商名录
      } else if (this.source === "JTGYSML") {
        return querySupplierDirectoryList;
      } else if (this.source === "100068JCCG") {
        return queryPurchasePriceList;
      } else {
        // 普通带docCode
        if (this.source) {
          return selectNoticeList;
        } else {
          return selectInformationPublishList;
        }
      }
    }
  }
};
</script>

<style scoped></style>
